/* eslint-disable consistent-return */
import React, { useEffect } from "react";
import {
  RootStore,
  useAppDispatch,
  useAppSelector,
} from "../../../../store/store";
import { roles } from "../../../../helpers/utils/Constants/roles";
import {
  getFilterdSprintByPathId,
  getLearningPathForSprintFilter,
  getOnBoarding,
  updateSelectedLearningPath,
} from "../../../../store/features/UserDashboard/NewUserDashboard/NewUserDashoardApi";
import { getRoleValue } from "../VideoTourCard/getSlugByUserrole";

const BannerText = () => {
  const authState: any = useAppSelector((store: RootStore) => store.AuthSlice);
  const dashState: any = useAppSelector(
    (store: RootStore) => store.NewDashboard
  );
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getLearningPathForSprintFilter());
    dispatch(getOnBoarding({page:getRoleValue(authState?.tac_user?.role)}));
  }, [dispatch]);

  // console.log(dashState.learning_path_for_filter);
  
  const getCourseNameByRole = (role: string) => {
    if (role === roles.SELF_PACED_PRODUCT_MANAGER_STUDENT) {
      return 99486;
    }
    if (role === roles.SELF_PACED_SCRUM_MASTER_STUDENT) {
      return 104442;
    }
  };

  useEffect(() => {
    if (dashState.req_success.get_path) {
      const checkSelected = dashState.learning_path_for_filter.filter(
        (lp: any) => lp?.path_id === getCourseNameByRole(authState?.tac_user?.role)
      );
      // console.log(checkSelected)
      if (checkSelected.length > 0) {
        dispatch(getFilterdSprintByPathId({ id: checkSelected[0].id }));
        dispatch(updateSelectedLearningPath({ id: checkSelected[0].id }));
      }
    }
  }, [
    dashState.req_success.get_path,
    dashState.learning_path_for_filter,
    dispatch,
  ]);

  return (
    <div className="text__and__select__section">
      <span className="welcome__text">
        Welcome, {authState?.tac_user?.first_name}!
      </span>

      <div className="text__wrapper">
        <p>
          You are on
          <span>{authState?.tac_user?.role ===
            roles.SELF_PACED_PRODUCT_MANAGER_STUDENT &&
            " Self Paced Product Manager "}
          {authState?.tac_user?.role ===
            roles.SELF_PACED_SCRUM_MASTER_STUDENT &&
            " Self Paced Scrum Master "}</span>
          track.
        </p>
      </div>
    </div>
  );
};

export default BannerText;
